import State from 'interfaces/state/State';

export const isError$ = (state: State): boolean => state.successPayment.isError;
export const isLoading$ = (state: State): boolean => state.successPayment.isLoading;
export const portal_session_id$ = (state: State): string | null => state.successPayment.portal_session_id;
export const errorText$ = (state: State): string | null => state.successPayment.errorText;
